import React, { useEffect, useState, useRef, useMemo } from "react";
import { Wrapper } from "./Wrapper";
import Icons from "../../icons";
import "./dateCalendar.scss";
import { useTranslation } from "react-i18next";

const DateCalendar = ({
  getSelectedDate,
  pastDate = "",
  pastDateType = "",
  selectionRange = [], // Add +1 Month to the required Month date
  selectionRangeType = "", // day or month
  disableHours = false,
  disableCustom = false,
  noDefaultSelected = false,
  disableOption = false
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedStartDateTime, setSelectedStartDateTime] = useState("");
  const [selectedEndDateTime, setSelectedEndDateTime] = useState("");
  const [isCustomActive, setIsCustomActive] = useState(false);
  const [isErrorActive, setIsErrorActive] = useState(false);
  const [isTimeSelected, setIsTimeSelected] = useState(false);
  const [errorMessageType, setErrorMessageType] = useState("");

  const [selectedTime, setSelectedTime] = useState("Last 1 Hour");
  const [showTimeOptions, setShowTimeOptions] = useState(false);
  const [customSelectedDate, setCustomSelectedDate] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [currentTimeOfSelected, setCurrentTimeOfSelected] = useState(
    new Date()
  );

  const [prevSelectedTime, setPrevSelectedTime] = useState("");
  const [customChecker, setCustomChecker] = useState(false);
  const [isCustomTimeSelected, setIsCustomTimeSelected] = useState(false);

  const { t } = useTranslation("reports");

  const handleCustomDateTime = (
    startDateTime,
    endDateTime,
    errorMsg,
    errorMsgType,
    isError,
    maxRangeError
  ) => {
    if (startDateTime) {
      setCustomChecker(false);
      setSelectedTime(`${startDateTime} - ${endDateTime}`);
      setShowTimeOptions(false);
      setSelectedStartDateTime(startDateTime);
      setSelectedEndDateTime(endDateTime);
      setIsCustomActive(true);
    }

    isError ? setIsErrorActive(true) : setIsErrorActive(false);

    if (errorMsgType === "durationError") {
      setErrorMessage(t("durationError"));
    } else if (errorMsgType === "rangeError") {
      setErrorMessage(
        t("rangeError", {
          maxRange: maxRangeError,
        })
      );
    }
  };

  useEffect(() => {
    if (selectedTime !== "Custom") {
      setShowTimeOptions(false);
      setShowOptions(false);
    }
  }, [selectedTime]);

  // Time Calculator Starts

  const handleTimeCalculation = (duration) => {
    const currentTime = new Date(); // This line is to get the current time

    switch (duration) {
      case 1:
        currentTime.setHours(currentTime.getHours() - 1); // Calculate the current time for the selected duration
        setPrevSelectedTime(selectedTime);
        setSelectedTime("Last 1 Hour ");
        setCustomChecker(false);
        setIsTimeSelected(true);
        break;
      case 3:
        currentTime.setHours(currentTime.getHours() - 3);
        setPrevSelectedTime(selectedTime);
        setSelectedTime("Last 3 Hours ");
        setCustomChecker(false);
        setIsTimeSelected(true);
        break;
      case 6:
        currentTime.setHours(currentTime.getHours() - 6);
        setPrevSelectedTime(selectedTime);
        setSelectedTime("Last 6 Hours ");
        setCustomChecker(false);
        setIsTimeSelected(true);
        break;
      case 12:
        currentTime.setHours(currentTime.getHours() - 12);
        setPrevSelectedTime(selectedTime);
        setSelectedTime("Last 12 Hours ");
        setCustomChecker(false);
        setIsTimeSelected(true);
        break;
      case 24:
        currentTime.setHours(currentTime.getHours() - 24);
        setPrevSelectedTime(selectedTime);
        setSelectedTime("Last 24 Hours ");
        setCustomChecker(false);
        setIsTimeSelected(true);
        break;
      case "reset":
        setPrevSelectedTime("Duration");
        setSelectedTime("Duration");
        setCustomChecker(false);
        setIsTimeSelected(false);
        break;
      default:
        break;
    }

    setCurrentTime(currentTime);
    setCurrentTimeOfSelected(new Date());
    setShowOptions(false);
    setShowTimeOptions(false);
    setIsCustomActive(false);
    setIsErrorActive(false);
    setIsCustomTimeSelected(false);
  };

  useEffect(() => {
    if (noDefaultSelected) {

      if(disableCustom === true || disableCustom === false ){
        handleTimeCalculation("reset");
      }
      
    } else {
      handleTimeCalculation(1);
    }
  }, [disableCustom, noDefaultSelected]);

  const formatTime = (time) => {
    return time.toISOString();
  };

  const last1HourTime = new Date();
  last1HourTime.setTime(currentTime.getTime());
  last1HourTime.setHours(last1HourTime.getHours() - 1);

  const [finalSelectedDate, setFinalSelectedDate] = useState([
    last1HourTime.toISOString(),
    new Date().toISOString(),
  ]);

  useEffect(() => {
    setCustomChecker(false);
    setCustomSelectedDate([
      formatTime(currentTime),
      formatTime(currentTimeOfSelected),
    ]);
    setPrevSelectedTime([
      formatTime(currentTime),
      formatTime(currentTimeOfSelected),
    ]);
  }, [currentTime, currentTimeOfSelected]);

  useEffect(() => {
    if (selectedTime.length > 15) {
      const customStartTime = selectedStartDateTime
        ? new Date(selectedStartDateTime)
        : null;
      const customEndTime = selectedEndDateTime
        ? new Date(selectedEndDateTime)
        : null;

      if (customStartTime && customEndTime) {
        if (
          !isNaN(customStartTime.getTime()) &&
          !isNaN(customEndTime.getTime())
        ) {
          const istStartTime = new Date(customStartTime);
          const customStartTimeUTC = istStartTime.toISOString();

          const istEndTime = new Date(customEndTime);
          const customEndTimeUTC = istEndTime.toISOString();

          setCustomChecker(false);
          setCustomSelectedDate([customStartTimeUTC, customEndTimeUTC]);
          setPrevSelectedTime([customStartTimeUTC, customEndTimeUTC]);
        }
      }
    }
  }, [selectedEndDateTime, selectedStartDateTime, selectedTime]);

  useEffect(() => {
    if (customSelectedDate.length === 2) {
      setCustomChecker(false);
      setFinalSelectedDate(customSelectedDate);
      setPrevSelectedTime(customSelectedDate);
    }
  }, [customSelectedDate]);

  // For checking final date data
  useEffect(() => {

    // console.log("finalSelectedDate", finalSelectedDate);
    
    getSelectedDate(
      finalSelectedDate,
      isCustomActive,
      isErrorActive,
      errorMessage,
      isTimeSelected
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalSelectedDate]);

  // Time Calculator Ends

  // CLose on Outside Click Starts

  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowOptions(false);
        setCustomChecker(true);
        setShowTimeOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [prevSelectedTime, selectedTime]);

  // CLose on Outside Click Ends

  // Open on Previous Filter retain if Calendar Cancel

  useEffect(() => {
    if (selectedTime === "Custom" && customChecker) {
      setSelectedTime(prevSelectedTime);
    }
  }, [customChecker]);

  // Close on Previous Filter retain if Calendar Cancel

  // Default Days Display

  let startTime = new Date(selectionRange[0]);
  let endTime = new Date(selectionRange[1]);
  let defaultDays;

  if (selectionRangeType === "day") {
    let timeDifferenceInMilliseconds = endTime.getTime() - startTime.getTime();
    let timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60);
    defaultDays = timeDifferenceInHours / 24;
  }

  useEffect(() => {
    if( selectedTime.length > 15){
      setIsCustomTimeSelected(true);
    }
  },[selectedTime])

  return (
    <div>
      {/*Calendar Section Starts */}

      <div className="calendarDivSectionContainer">
        <div
          className={`calendarDivSectionListContainer ${
            showTimeOptions ? "bordered" : ""
          }`}
        >
          <div className="calendarDivSectionSelectedDateTimeContainer">
            <div
              className={`calendarDivSectionSelectedTimeContainer ${
                selectedTime.length > 15 ? "lengthactive" : ""
              } ${showTimeOptions ? "bordered" : ""} ${disableOption ? "disabled" : "active"}`}
              id={`${!isTimeSelected ? "calendarNotSelected" : ""}`}
              onClick={() => {
                if(!disableOption){
                  setShowTimeOptions(!showTimeOptions);
                  setShowOptions(false);
                }
              }}
            >
              {showTimeOptions ? (
                <>{Icons.clockTimeIcon} </>
              ) : (
                <>{Icons.clockWhiteIcon}</>
              )}

              <span className="selected-time">{selectedTime}</span>

              {showTimeOptions ? (
                <span className="upDownArrowIcons">{Icons.chevronPurpleUpArrowIcon} </span>
              ) : (
                <span className="upDownArrowIcons">{Icons.chevronDownWhiteIcon}</span>
              )}
            </div>
            {showTimeOptions && (
              <ul
                className={`timeOptions ${
                  selectedTime.length > 15 ? "lengthactive" : ""
                }
                ${showTimeOptions ? "bordered" : ""}`}
                ref={wrapperRef}
              >
                <li
                  className={`hourListing ${
                    selectedTime.length === 14 ? "length12active" : ""
                  } 1Hour`}
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      setCustomChecker(false);
                      handleTimeCalculation(1);
                    }
                  }}
                >
                  Last 1 Hour
                </li>
                <li
                  className={`hourListing ${
                    selectedTime.length === 14 ? "length12active" : ""
                  } 3Hour`}
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      setCustomChecker(false);
                      handleTimeCalculation(3);
                    }
                  }}
                >
                  Last 3 Hours
                </li>
                <li
                  className={`hourListing ${
                    selectedTime.length === 14 ? "length12active" : ""
                  } 6Hour`}
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      setCustomChecker(false);
                      handleTimeCalculation(6);
                    }
                  }}
                >
                  Last 6 Hours
                </li>
                <li
                  className={`hourListing ${
                    selectedTime.length === 14 ? "length12active" : ""
                  } 12Hour`}
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      setCustomChecker(false);
                      handleTimeCalculation(12);
                    }
                  }}
                >
                  Last 12 Hours
                </li>
                <li
                  className={`hourListing ${
                    selectedTime.length === 14 ? "length12active" : ""
                  } 24Hour`}
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      setCustomChecker(false);
                      handleTimeCalculation(24);
                    }
                  }}
                >
                  Last 24 Hours
                </li>
                <li
                  className={` hourListing ${
                    selectedTime.length === 14 ? "length12active" : ""
                  } custom`}
                  id={disableCustom ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableCustom) {
                      setShowOptions(!showOptions);
                      setPrevSelectedTime(selectedTime);
                      setSelectedTime("Custom");
                      setShowTimeOptions(false);
                      setIsTimeSelected(true);
                    }
                  }}
                >
                  Custom
                </li>
              </ul>
            )}
          </div>
        </div>
        {showOptions && (
          <div className="presetOptionsContainer" ref={wrapperRef}>
            <div
              className={`calendarDivSection ${
                selectedTime.length > 15 ? "active" : ""
              }`}
            >
              <Wrapper
                onData={handleCustomDateTime}
                pastDate={pastDate}
                pastDateType={pastDateType}
                selectionRange={selectionRange}
                selectionRangeType={selectionRangeType}
                defaultDays={defaultDays}
                customSelectedDateTime={finalSelectedDate}
                isCustomSelected={isCustomTimeSelected}
              />
            </div>

            <div className="presetOptions">
              <span>Preset</span>
              <ul
                className={`timeOptionsPreset ${
                  selectedTime.length > 15 ? "lengthactive" : ""
                } ${showOptions ? "bordered" : ""}`}
              >
                <li
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      handleTimeCalculation(1);
                    }
                  }}
                >
                  Last 1 Hour
                </li>
                <li
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      handleTimeCalculation(3);
                    }
                  }}
                >
                  Last 3 Hours
                </li>
                <li
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      handleTimeCalculation(6);
                    }
                  }}
                >
                  Last 6 Hours
                </li>
                <li
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      handleTimeCalculation(12);
                    }
                  }}
                >
                  Last 12 Hours
                </li>
                <li
                  id={disableHours ? "disabledState" : ""}
                  onClick={() => {
                    if (!disableHours) {
                      handleTimeCalculation(24);
                    }
                  }}
                >
                  Last 24 Hours
                </li>
                <li
                  className={`customOption ${
                    selectedTime === "Custom" ? "customSelected" : ""
                  }`}
                >
                  Custom
                </li>
              </ul>
            </div>
            {/* {errorMessage && (
              <div className="errorMessageContainer">{errorMessage}</div>
            )} */}
          </div>
        )}
      </div>
    </div>
  );
};

export default DateCalendar;
